export const SIMPLE_DIALOG_WRAPPER_ID = 'simple_dialog_wrapper';
export const APP_LINK_DIALOG_WRAPPER_ID = 'applink-dialog';
